// ============================================================
// Lunar Studios — Rental Cart Engine
// assets/rental-cart.js  |  Step 2
// ============================================================

const RentalCart = (() => {
  const KEY = 'lunarRentalCart';

  function getCart() {
    try { return JSON.parse(localStorage.getItem(KEY)) || { items: [], dates: {}, note: '' }; }
    catch (e) { return { items: [], dates: {}, note: '' }; }
  }

  function saveCart(cart) {
    localStorage.setItem(KEY, JSON.stringify(cart));
    _updateBadge(cart.items.length);
    document.dispatchEvent(new CustomEvent('rental-cart:updated', { detail: cart }));
  }

  function _updateBadge(count) {
    ['rental-cart-count', 'rental-cart-count-mobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = count;
    });
    ['rental-cart-icon-bubble', 'rental-cart-icon-bubble-mobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.setAttribute('data-count', count);
    });
  }

  function addItem(item) {
    var cart = getCart();
    var existing = cart.items.find(function(i) {
      return i.id === item.id && i.duration === item.duration;
    });
    if (existing) {
      existing.qty += (item.qty || 1);
    } else {
      cart.items.push(Object.assign({}, item, { qty: item.qty || 1, addedAt: Date.now() }));
    }
    saveCart(cart);
  }

  function removeItem(id, duration) {
    var cart = getCart();
    cart.items = cart.items.filter(function(i) {
      return !(i.id == id && i.duration == duration);
    });
    saveCart(cart);
  }

  function updateQty(id, duration, qty) {
    var cart = getCart();
    var item = cart.items.find(function(i) { return i.id == id && i.duration == duration; });
    if (item) {
      if (qty <= 0) { removeItem(id, duration); return; }
      item.qty = qty;
      saveCart(cart);
    }
  }

  function updateDates(startDate, endDate) {
    var cart = getCart();
    cart.dates = { start: startDate, end: endDate };
    saveCart(cart);
  }

  function updateNote(note) {
    var cart = getCart();
    cart.note = note;
    saveCart(cart);
  }

  function clearCart() {
    localStorage.removeItem(KEY);
    _updateBadge(0);
    document.dispatchEvent(new CustomEvent('rental-cart:updated', { detail: getCart() }));
  }

  function isInCart(productId) {
    return getCart().items.some(function(i) { return i.id == productId; });
  }

  function getCount() {
    return getCart().items.length;
  }

  // Initialise badge on every page load
  document.addEventListener('DOMContentLoaded', function() {
    _updateBadge(getCart().items.length);
  });

  return { getCart, saveCart, addItem, removeItem, updateQty, updateDates, updateNote, clearCart, isInCart, getCount };
})();

window.RentalCart = RentalCart;


// ============================================================
// Product Page — Duration Pills + Add to Rental Cart
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  // Find all rental cart add buttons on the page (handles quick-add modals too)
  document.querySelectorAll('.rental-cart-add-btn').forEach(function(addBtn) {
    var productId = addBtn.dataset.productId;
    var sectionId = addBtn.dataset.sectionId;
    var pillsContainer = document.getElementById('rental-duration-pills-' + sectionId);
    var selectedDays = 1;

    // Set initial state if already in cart
    if (RentalCart.isInCart(productId)) {
      addBtn.textContent = '\u2713 In Rental Cart';
      addBtn.classList.add('added');
    }

    // Duration pill selection
    if (pillsContainer) {
      pillsContainer.querySelectorAll('.rental-dur-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          pillsContainer.querySelectorAll('.rental-dur-pill').forEach(function(p) {
            p.classList.remove('active');
          });
          pill.classList.add('active');
          selectedDays = parseInt(pill.dataset.days, 10);
        });
      });
    }

    // Add to Rental Cart
    addBtn.addEventListener('click', function() {
      var qtyInput = document.querySelector('.quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      RentalCart.addItem({
        id: productId,
        handle: addBtn.dataset.productHandle,
        title: addBtn.dataset.productTitle,
        brand: addBtn.dataset.productVendor,
        image: addBtn.dataset.productImage,
        price: parseInt(addBtn.dataset.productPrice, 10),
        variantId: addBtn.dataset.productVariantId,
        sku: addBtn.dataset.productSku,
        duration: selectedDays,
        qty: qty
      });

      addBtn.textContent = '\u2713 Added to Rental Cart';
      addBtn.classList.add('added');
    });
  });
});

// ============================================================
// Rental Cart Drawer Controller
// ============================================================

var RentalCartDrawer = (function() {

  function getEls() {
    return {
      drawer:   document.getElementById('rental-cart-drawer'),
      overlay:  document.getElementById('rental-cart-overlay'),
      items:    document.getElementById('rental-cart-drawer-items'),
      empty:    document.getElementById('rental-cart-drawer-empty'),
      footer:   document.getElementById('rental-cart-drawer-footer'),
      subtitle: document.getElementById('rental-cart-drawer-subtitle'),
      startDate:document.getElementById('rental-start-date'),
      endDate:  document.getElementById('rental-end-date'),
      note:     document.getElementById('rental-cart-note')
    };
  }

  function renderItems() {
    var e = getEls();
    if (!e.drawer) return;
    var cart = RentalCart.getCart();
    var items = cart.items;
    var hasItems = items.length > 0;

    // Update subtitle
    if (e.subtitle) {
      e.subtitle.textContent = items.length ? items.length + ' item' + (items.length !== 1 ? 's' : '') : '';
    }

    // Show/hide empty vs footer
    if (e.empty)  e.empty.style.display  = hasItems ? 'none' : 'block';
    if (e.footer) e.footer.style.display = hasItems ? 'block' : 'none';

    // Restore saved dates and note
    if (e.startDate && cart.dates && cart.dates.start) e.startDate.value = cart.dates.start;
    if (e.endDate   && cart.dates && cart.dates.end)   e.endDate.value   = cart.dates.end;
    if (e.note      && cart.note)                       e.note.value      = cart.note;

    if (!e.items) return;

    if (!hasItems) {
      e.items.innerHTML = '';
      return;
    }

    e.items.innerHTML = items.map(function(item) {
      var imgSrc = item.image || '';
      var imgTag = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + item.title + '" width="60" height="60" loading="lazy">'
        : '';
      return [
        '<div class="rental-cart-item" data-id="' + item.id + '" data-duration="' + item.duration + '">',
        '  <div class="rental-cart-item__image">' + imgTag + '</div>',
        '  <div class="rental-cart-item__details">',
        '    <div class="rental-cart-item__brand">' + (item.brand || '') + '</div>',
        '    <div class="rental-cart-item__name">' + item.title + '</div>',
        '    <div class="rental-cart-item__meta">' + item.duration + ' day' + (item.duration > 1 ? 's' : '') + ' &middot; Qty ' + item.qty + '</div>',
        '  </div>',
        '  <button class="rental-cart-item__remove" type="button" aria-label="Remove ' + item.title + '" data-id="' + item.id + '" data-duration="' + item.duration + '">&times;</button>',
        '</div>'
      ].join('\n');
    }).join('\n');

    // Wire up remove buttons
    e.items.querySelectorAll('.rental-cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        RentalCart.removeItem(btn.dataset.id, parseInt(btn.dataset.duration, 10));
        renderItems();
        // Update product page button state if product is no longer in cart
        document.querySelectorAll('.rental-cart-add-btn').forEach(function(addBtn) {
          if (addBtn.dataset.productId === btn.dataset.id) {
            if (!RentalCart.isInCart(btn.dataset.id)) {
              addBtn.textContent = 'Add to Rental Cart';
              addBtn.classList.remove('added');
            }
          }
        });
      });
    });
  }

  function open() {
    var e = getEls();
    if (!e.drawer) return;
    renderItems();
    e.drawer.classList.add('active');
    if (e.overlay) e.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    e.drawer.setAttribute('aria-hidden', 'false');
  }

  function close() {
    var e = getEls();
    if (!e.drawer) return;
    e.drawer.classList.remove('active');
    if (e.overlay) e.overlay.classList.remove('active');
    document.body.style.overflow = '';
    e.drawer.setAttribute('aria-hidden', 'true');
  }

  function init() {
    // Wire up the nav trigger
    document.addEventListener('click', function(ev) {
      var trigger = ev.target.closest('#rental-cart-trigger, .rental-cart-open-trigger');
      if (trigger) {
        ev.preventDefault();
        open();
        return;
      }
      var closeBtn = ev.target.closest('.rental-cart-drawer__close');
      if (closeBtn) { close(); return; }
    });

    // Keyboard close
    document.addEventListener('keydown', function(ev) {
      if (ev.key === 'Escape') close();
    });

    // Date persistence
    document.addEventListener('change', function(ev) {
      if (ev.target.id === 'rental-start-date' || ev.target.id === 'rental-end-date') {
        var startEl = document.getElementById('rental-start-date');
        var endEl   = document.getElementById('rental-end-date');
        RentalCart.updateDates(
          startEl ? startEl.value : '',
          endEl   ? endEl.value   : ''
        );
      }
    });

    // Note persistence
    document.addEventListener('input', function(ev) {
      if (ev.target.id === 'rental-cart-note') {
        RentalCart.updateNote(ev.target.value);
      }
    });

    // Re-render when cart updates
    document.addEventListener('rental-cart:updated', function() {
      var drawer = document.getElementById('rental-cart-drawer');
      if (drawer && drawer.classList.contains('active')) {
        renderItems();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return { open: open, close: close, renderItems: renderItems };
})();

window.RentalCartDrawer = RentalCartDrawer;

// ============================================================
// Quote Form Page — populate summary + hidden fields
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  var summaryEl = document.getElementById('rental-quote-summary');
  var form = document.getElementById('rental-quote-form');
  if (!summaryEl || !form) return;

  var cart = RentalCart.getCart();
  var items = cart.items;

  // Generate a quote reference number
  var refNum = 'LUN-' + new Date().getFullYear() + '-' + String(Date.now()).slice(-4);

  // Build summary HTML
  if (items.length === 0) {
    summaryEl.innerHTML = '<span class="rental-quote__summary-label">Your rental cart is empty.</span>' +
      '<p style="opacity:.6;font-size:1.3rem;margin-top:.5rem"><a href="/collections/lighting" style="color:inherit">Browse gear &rarr;</a></p>';
  } else {
    var itemsHTML = items.map(function(item) {
      return '<div class="rental-quote__summary-item"><span>' + item.title + '</span>' +
        '<strong>' + item.duration + ' day' + (item.duration > 1 ? 's' : '') + ' &times; ' + item.qty + '</strong></div>';
    }).join('');

    var datesHTML = '';
    if (cart.dates && (cart.dates.start || cart.dates.end)) {
      datesHTML = '<div class="rental-quote__summary-dates rental-quote__summary-item">' +
        '<span>Shoot Dates</span>' +
        '<strong>' + (cart.dates.start || '—') + ' &rarr; ' + (cart.dates.end || '—') + '</strong>' +
        '</div>';
    }

    summaryEl.innerHTML =
      '<span class="rental-quote__summary-label">Rental Cart &mdash; ' + items.length + ' item' + (items.length !== 1 ? 's' : '') + '</span>' +
      itemsHTML + datesHTML;
  }

  // Populate hidden fields
  var itemsField  = document.getElementById('rq-items-field');
  var datesField  = document.getElementById('rq-dates-field');
  var refField    = document.getElementById('rq-ref-field');

  if (itemsField) {
    itemsField.value = items.map(function(i) {
      return i.title + ' (' + i.duration + 'd x' + i.qty + ')';
    }).join(', ');
  }
  if (datesField && cart.dates) {
    datesField.value = (cart.dates.start || '') + ' to ' + (cart.dates.end || '');
  }
  if (refField) refField.value = refNum;

  // On submit: store ref + name + email for confirmation page, then clear cart
  form.addEventListener('submit', function() {
    var firstName = (document.getElementById('rq-first-name') || {}).value || '';
    var email     = (document.getElementById('rq-email') || {}).value || '';
    try {
      sessionStorage.setItem('lunarQuoteRef',   refNum);
      sessionStorage.setItem('lunarQuoteName',  firstName);
      sessionStorage.setItem('lunarQuoteEmail', email);
    } catch(e) {}
    RentalCart.clearCart();
  });
});

// ============================================================
// Quote Form — populate CC field + formatted body for emails
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    var firstName  = (document.getElementById('rq-first-name')  || {}).value || '';
    var lastName   = (document.getElementById('rq-last-name')   || {}).value || '';
    var email      = (document.getElementById('rq-email')       || {}).value || '';
    var phone      = (document.getElementById('rq-phone')       || {}).value || '';
    var company    = (document.getElementById('rq-company')     || {}).value || '';
    var shootType  = (document.getElementById('rq-shoot-type')  || {}).value || '';
    var delivery   = (document.getElementById('rq-delivery')    || {}).value || '';
    var notes      = (document.getElementById('rq-notes')       || {}).value || '';
    var gearList   = (document.getElementById('rq-items-field') || {}).value || '';
    var shootDates = (document.getElementById('rq-dates-field') || {}).value || '';
    var quoteRef   = (document.getElementById('rq-ref-field')   || {}).value || '';

    // Set CC to customer email so they receive a copy of the team notification
    var ccField = document.getElementById('rq-cc-field');
    if (ccField && email) ccField.value = email;

    // Build a well-formatted body that reads well for both team and customer
    var gearLines = gearList.split(', ').map(function(g) { return '  • ' + g; }).join('\n');
    var deliveryShort = delivery.indexOf('Pickup') > -1 ? 'Pickup from 42 Maddox St, Alexandria' : 'Sydney Metro Delivery';

    var formattedBody = [
      '⚡ NEW RENTAL QUOTE REQUEST',
      'Ref: ' + quoteRef,
      '----------------------------------------',
      '',
      'CUSTOMER',
      '  Name:     ' + firstName + ' ' + lastName,
      '  Email:    ' + email,
      '  Phone:    ' + (phone || 'Not provided'),
      '  Company:  ' + (company || 'Not provided'),
      '',
      'GEAR LIST',
      gearLines,
      '',
      'SHOOT DETAILS',
      '  Dates:     ' + shootDates,
      '  Type:      ' + shootType,
      '  Delivery:  ' + deliveryShort,
      '',
      (notes ? 'NOTES\n  ' + notes + '\n\n' : ''),
      '----------------------------------------',
      'Reply to quote: ' + email,
      'View in Current RMS: https://lunar.current-rms.com/opportunities',
      '',
      '--- Customer copy below ---',
      '',
      'Hi ' + firstName + ',',
      '',
      'Thanks for your rental quote request (Ref: ' + quoteRef + ').',
      'We will review your gear list and come back within 2 business hours.',
      '',
      'YOUR GEAR',
      gearLines,
      '',
      'SHOOT DATES: ' + shootDates,
      '',
      'WHAT HAPPENS NEXT',
      '  1. We check availability and prepare your custom quote',
      '  2. Quote emailed to you within 2 business hours',
      '  3. Confirm, pay a deposit — booking locked in',
      '',
      'Questions? Call 02 8553 0333 or reply to this email.',
      '',
      'LUNAR Studios · 42 Maddox St, Alexandria NSW 2015',
      'equipment@lunarstudios.au · lunarstudios.au'
    ].join('\n');

    // Inject formatted body into a hidden field
    var bodyField = form.querySelector('[name="contact[body]"]');
    if (!bodyField) {
      bodyField = document.createElement('input');
      bodyField.type = 'hidden';
      bodyField.name = 'contact[body]';
      form.appendChild(bodyField);
    }
    bodyField.value = formattedBody;
  });
});

// send-email-outlook
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;
  form.addEventListener('submit', function() {
    var fn = (document.getElementById('rq-first-name')||{}).value||'';
    var ln = (document.getElementById('rq-last-name')||{}).value||'';
    var em = (document.getElementById('rq-email')||{}).value||'';
    var ph = (document.getElementById('rq-phone')||{}).value||'';
    var co = (document.getElementById('rq-company')||{}).value||'';
    var st = (document.getElementById('rq-shoot-type')||{}).value||'';
    var dl = (document.getElementById('rq-delivery')||{}).value||'';
    var nt = (document.getElementById('rq-notes')||{}).value||'';
    var gl = (document.getElementById('rq-items-field')||{}).value||'';
    var sd = (document.getElementById('rq-dates-field')||{}).value||'';
    var qr = (document.getElementById('rq-ref-field')||{}).value||'';
    if (!em) return;
    var gear = gl.split(', ').map(function(g){return '  * '+g;}).join('\n');
    var API = 'https://rms-proxy-production.up.railway.app/send-email';
    var custBody = 'Hi '+fn+',\n\nThanks for your rental quote request. We will come back to you within 2 business hours.\n\nQUOTE REF: '+qr+'\n\nYOUR GEAR\n'+gear+'\n\nSHOOT DATES: '+sd+'\nSHOOT TYPE: '+st+'\n\nWHAT HAPPENS NEXT\n  1. We check availability and prepare your custom quote\n  2. Quote emailed within 2 business hours\n  3. Confirm + deposit = booking locked in\n\nQuestions? 02 8553 0333 or reply to this email.\n\nLUNAR Studios\n42 Maddox St, Alexandria NSW 2015\nequipment@lunarstudios.au';
    var teamBody = 'NEW RENTAL REQUEST - '+qr+'\n\nCUSTOMER\n  Name: '+fn+' '+ln+'\n  Email: '+em+'\n  Phone: '+(ph||'--')+'\n  Company: '+(co||'--')+'\n\nGEAR\n'+gear+'\n\nDETAILS\n  Dates: '+sd+'\n  Type: '+st+'\n  Delivery: '+dl+'\n  Notes: '+(nt||'--')+'\n\nReply: '+em+'\nRMS: https://lunar.current-rms.com/opportunities';
    fetch(API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({to:em,subject:'Your Rental Quote Request - Ref '+qr,text:custBody,from_name:'LUNAR Studios Equipment'})}).catch(function(){});
    fetch(API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({to:['equipment@lunarstudios.au','studios@lunarstudios.au'],subject:'New Rental Request - '+fn+' '+ln+' - '+qr,text:teamBody,from_name:'LUNAR Studios Website'})}).catch(function(){});
  });
});

// ============================================================
// Quote Form — subscribe customer to marketing for Flow emails
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    var email     = (document.getElementById('rq-email')      || {}).value || '';
    var firstName = (document.getElementById('rq-first-name') || {}).value || '';
    var lastName  = (document.getElementById('rq-last-name')  || {}).value || '';
    var phone     = (document.getElementById('rq-phone')      || {}).value || '';
    var company   = (document.getElementById('rq-company')    || {}).value || '';
    if (!email) return;

    // Create/update customer as marketing subscriber so Flow can send them email
    var mutation = [
      'mutation {',
      '  customerCreate(input: {',
      '    email: ' + JSON.stringify(email) + ',',
      '    firstName: ' + JSON.stringify(firstName) + ',',
      '    lastName: ' + JSON.stringify(lastName) + ',',
      '    phone: ' + JSON.stringify(phone || '') + ',',
      '    tags: ["rental-quote-subscriber"],',
      '    emailMarketingConsent: {',
      '      marketingState: SUBSCRIBED,',
      '      marketingOptInLevel: SINGLE_OPT_IN',
      '    }',
      '  }) {',
      '    customer { id email }',
      '    userErrors { field message }',
      '  }',
      '}'
    ].join('\n');

    // Fire and forget — if customer exists already, upsert via customerUpdate
    fetch('/store/ba617e-c8/api/unstable/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: mutation })
    }).then(function(res) {
      return res.json();
    }).then(function(data) {
      var errors = data?.data?.customerCreate?.userErrors || [];
      // If email already taken, find and update existing customer
      var emailTaken = errors.some(function(e) { return e.field && e.field.includes('email'); });
      if (emailTaken) {
        // Search for existing customer and update their marketing consent
        var searchQuery = '{ customers(first: 1, query: "email:' + email + '") { edges { node { id } } } }';
        fetch('/store/ba617e-c8/api/unstable/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: searchQuery })
        }).then(function(r2) { return r2.json(); }).then(function(d2) {
          var customerId = d2?.data?.customers?.edges?.[0]?.node?.id;
          if (customerId) {
            var updateMutation = [
              'mutation {',
              '  customerUpdate(input: {',
              '    id: ' + JSON.stringify(customerId) + ',',
              '    emailMarketingConsent: {',
              '      marketingState: SUBSCRIBED,',
              '      marketingOptInLevel: SINGLE_OPT_IN',
              '    }',
              '  }) {',
              '    customer { id email }',
              '    userErrors { field message }',
              '  }',
              '}'
            ].join('\n');
            fetch('/store/ba617e-c8/api/unstable/graphql.json', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ query: updateMutation })
            }).catch(function() {});
          }
        }).catch(function() {});
      }
    }).catch(function() {});
  });
});

// ============================================================
// Quote Form — create metaobject to trigger Flow workflow
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    var firstName  = (document.getElementById('rq-first-name')  || {}).value || '';
    var lastName   = (document.getElementById('rq-last-name')   || {}).value || '';
    var email      = (document.getElementById('rq-email')       || {}).value || '';
    var phone      = (document.getElementById('rq-phone')       || {}).value || '';
    var company    = (document.getElementById('rq-company')     || {}).value || '';
    var shootType  = (document.getElementById('rq-shoot-type')  || {}).value || '';
    var delivery   = (document.getElementById('rq-delivery')    || {}).value || '';
    var notes      = (document.getElementById('rq-notes')       || {}).value || '';
    var gearList   = (document.getElementById('rq-items-field') || {}).value || '';
    var shootDates = (document.getElementById('rq-dates-field') || {}).value || '';
    var quoteRef   = (document.getElementById('rq-ref-field')   || {}).value || '';
    if (!email || !quoteRef) return;

    var mutation = `mutation {
      metaobjectCreate(metaobject: {
        type: "rental_quote",
        fields: [
          { key: "first_name",  value: ` + JSON.stringify(firstName)  + ` },
          { key: "last_name",   value: ` + JSON.stringify(lastName)   + ` },
          { key: "email",       value: ` + JSON.stringify(email)      + ` },
          { key: "phone",       value: ` + JSON.stringify(phone)      + ` },
          { key: "company",     value: ` + JSON.stringify(company)    + ` },
          { key: "shoot_type",  value: ` + JSON.stringify(shootType)  + ` },
          { key: "delivery",    value: ` + JSON.stringify(delivery)   + ` },
          { key: "notes",       value: ` + JSON.stringify(notes)      + ` },
          { key: "gear_list",   value: ` + JSON.stringify(gearList)   + ` },
          { key: "shoot_dates", value: ` + JSON.stringify(shootDates) + ` },
          { key: "quote_ref",   value: ` + JSON.stringify(quoteRef)   + ` }
        ]
      }) {
        metaobject { id handle }
        userErrors { field message }
      }
    }`;

    fetch('/store/ba617e-c8/api/unstable/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: mutation })
    }).catch(function() {});
  });
});

// klaviyo-rental-quote
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    var fn  = (document.getElementById('rq-first-name')  || {}).value || '';
    var ln  = (document.getElementById('rq-last-name')   || {}).value || '';
    var em  = (document.getElementById('rq-email')       || {}).value || '';
    var ph  = (document.getElementById('rq-phone')       || {}).value || '';
    var co  = (document.getElementById('rq-company')     || {}).value || '';
    var st  = (document.getElementById('rq-shoot-type')  || {}).value || '';
    var dl  = (document.getElementById('rq-delivery')         || {}).value || '';
    var dlPostcode = (document.getElementById('rq-delivery-postcode') || {}).value || '';
    var dlSuburb   = (document.getElementById('rq-delivery-suburb')   || {}).value || '';
    var dlTime     = (document.getElementById('rq-delivery-time')     || {}).value || '';
    var nt  = (document.getElementById('rq-notes')       || {}).value || '';
    var sd  = (document.getElementById('rq-dates-field') || {}).value || '';
    var qr  = (document.getElementById('rq-ref-field')   || {}).value || '';
    if (!em) return;

    // Build enriched gear list — "Title (Xd xQty @$Rate) $LineTotal"
    var gl = '';
    try {
      var cart = typeof RentalCart !== 'undefined' && RentalCart.getCart ? RentalCart.getCart() : null;
      if (cart && cart.items && cart.items.length) {
        gl = cart.items.map(function(item) {
          var rate      = Math.round((item.price || 0) / 100);
          var lineTotal = rate * (item.qty || 1) * (item.duration || 1);
          return item.title
            + ' (' + (item.duration || 1) + 'd'
            + ' x' + (item.qty || 1)
            + ' @$' + rate + '/d)'
            + ' $' + lineTotal;
        }).join('\n');
      }
    } catch(e) {}

    // Fallback to hidden field if cart parsing fails
    if (!gl) gl = (document.getElementById('rq-items-field') || {}).value || '';

    var RAILWAY = 'https://rms-proxy-production.up.railway.app';
    var K = 'RbdsnC';

    // 1. Email is now sent server-side by /create-rms-opportunity
    //    (Sequential flow ensures customer email includes the RMS ES number)

    // 2. Create RMS opportunity
    fetch(RAILWAY + '/create-rms-opportunity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        first_name: fn, last_name: ln, email: em, phone: ph,
        company: co, shoot_type: st, delivery: dl,
        delivery_postcode: dlPostcode, delivery_suburb: dlSuburb, delivery_time: dlTime,
        notes: nt, gear_list: gl, shoot_dates: sd, quote_ref: qr
      })
    }).catch(function() {});
  

    // 3. Klaviyo event (analytics)
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + K, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({ data: { type: 'profile', attributes: {
        email: em, first_name: fn, last_name: ln, phone_number: ph, organization: co
      }}})
    }).catch(function() {});

    fetch('https://a.klaviyo.com/client/events/?company_id=' + K, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({ data: { type: 'event', attributes: {
        metric:  { data: { type: 'metric', attributes: { name: 'Rental Quote Submitted' } } },
        profile: { data: { type: 'profile', attributes: { email: em } } },
        properties: {
          quote_ref: qr, first_name: fn, last_name: ln, email: em,
          phone: ph, company: co, gear_list: gl, shoot_dates: sd,
          shoot_type: st, delivery: dl, notes: nt
        }
      }}})
    }).catch(function() {});
  });
});

// ── Rental Cart Pricing Table ─────────────────────────────────────────────
function updateRentalCartPricing() {
  var pricingEl  = document.getElementById('rental-cart-pricing');
  var rowsEl     = document.getElementById('rental-cart-pricing-rows');
  var totalsEl   = document.getElementById('rental-cart-pricing-totals');
  if (!pricingEl || !rowsEl || !totalsEl) return;

  var cart = RentalCart.getCart ? RentalCart.getCart() : null;
  var items = (cart && cart.items) ? cart.items : [];

  if (!items.length) {
    pricingEl.style.display = 'none';
    return;
  }

  var hireTotal = 0;
  var rowsHTML  = '';

  items.forEach(function(item) {
    var rate      = Math.round((item.price || 0) / 100);
    var dur       = item.duration || 1;
    var qty       = item.qty      || 1;
    var lineTotal = rate * dur * qty;
    hireTotal    += lineTotal;
    rowsHTML     += '<tr>'
      + '<td class="rc-col-item">'  + item.title + '</td>'
      + '<td class="rc-col-dur">'   + dur + 'd</td>'
      + '<td class="rc-col-qty">'   + qty + '</td>'
      + '<td class="rc-col-rate">$' + rate + '/d</td>'
      + '<td class="rc-col-cost">$' + lineTotal + '</td>'
      + '</tr>';
  });

  var waiver = Math.round(hireTotal * 0.1);
  var total  = hireTotal + waiver;

  var totalsHTML = ''
    + '<tr class="rental-cart-pricing__tfoot-hire">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Estimated Hire Total</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + hireTotal + '</td>'
    + '</tr>'
    + '<tr class="rental-cart-pricing__tfoot-waiver">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Damage Waiver (10%)</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + waiver + '</td>'
    + '</tr>'
    + '<tr class="rental-cart-pricing__tfoot-total">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Estimated Total</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + total + '</td>'
    + '</tr>';

  rowsEl.innerHTML  = rowsHTML;
  totalsEl.innerHTML = totalsHTML;
  pricingEl.style.display = 'block';
}

// Move the pricing table to the right position on the quote page and hide old summary
function repositionQuotePricing() {
  var pricingEl = document.getElementById('rental-quote-pricing');
  var summaryEl = document.querySelector('.rental-quote__summary');
  if (!pricingEl || !summaryEl) return;

  // Move pricing table to sit right after the summary box (if not already there)
  var parent = summaryEl.parentNode;
  if (pricingEl.previousElementSibling !== summaryEl) {
    parent.insertBefore(pricingEl, summaryEl.nextSibling);
  }

  // Hide the old simple summary box — pricing table supersedes it
  var cart  = RentalCart.getCart ? RentalCart.getCart() : null;
  var items = (cart && cart.items) ? cart.items : [];
  if (items.length > 0) {
    summaryEl.classList.add('rental-quote__summary--hidden');
  } else {
    summaryEl.classList.remove('rental-quote__summary--hidden');
    pricingEl.style.display = 'none';
  }
}


// Also update the rental QUOTE PAGE pricing table (same logic, different IDs)
function updateQuotePagePricing() {
  var pricingEl = document.getElementById('rental-quote-pricing');
  var rowsEl    = document.getElementById('rental-quote-pricing-rows');
  var totalsEl  = document.getElementById('rental-quote-pricing-totals');
  if (!pricingEl || !rowsEl || !totalsEl) return;

  var cart  = RentalCart.getCart ? RentalCart.getCart() : null;
  var items = (cart && cart.items) ? cart.items : [];

  if (!items.length) { pricingEl.style.display = 'none'; return; }

  var hireTotal = 0;
  var rowsHTML  = '';

  items.forEach(function (item) {
    var rate      = Math.round((item.price || 0) / 100);
    var dur       = item.duration || 1;
    var qty       = item.qty      || 1;
    var lineTotal = rate * dur * qty;
    hireTotal    += lineTotal;

    function stepper(field, label) {
      return '<span class="rq-stepper" data-field="' + field + '" data-id="' + item.id + '" data-duration="' + dur + '">'
        +   '<button type="button" class="rq-stepper__btn" data-step="-1" aria-label="Decrease">&minus;</button>'
        +   '<span class="rq-stepper__val">' + label + '</span>'
        +   '<button type="button" class="rq-stepper__btn" data-step="1" aria-label="Increase">+</button>'
        + '</span>';
    }

    rowsHTML += '<tr>'
      + '<td class="rc-col-item">' + item.title + '</td>'
      + '<td class="rc-col-dur">'  + stepper('duration', dur + 'd') + '</td>'
      + '<td class="rc-col-qty">'  + stepper('qty', qty) + '</td>'
      + '<td class="rc-col-rate">$' + rate + '/d</td>'
      + '<td class="rc-col-cost">$' + lineTotal + '</td>'
      + '</tr>';
  });

  var waiver = Math.round(hireTotal * 0.1);
  var total  = hireTotal + waiver;

  var totalsHTML = ''
    + '<tr class="rental-cart-pricing__tfoot-hire">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Estimated Hire Total</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + hireTotal + '</td>'
    + '</tr>'
    + '<tr class="rental-cart-pricing__tfoot-waiver">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Damage Waiver (10%)</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + waiver + '</td>'
    + '</tr>'
    + '<tr class="rental-cart-pricing__tfoot-total">'
    +   '<td class="rental-cart-pricing__tfoot-label" colspan="3">Estimated Total</td>'
    +   '<td class="rental-cart-pricing__tfoot-gst">inc GST</td>'
    +   '<td class="rental-cart-pricing__tfoot-amount">$' + total + '</td>'
    + '</tr>';

  rowsEl.innerHTML   = rowsHTML;
  totalsEl.innerHTML = totalsHTML;
  pricingEl.style.display = 'block';
}

// Hook into cart update events
document.addEventListener('rental-cart:updated', updateRentalCartPricing);
document.addEventListener('rental-cart:updated', updateQuotePagePricing);
document.addEventListener('rental-cart:updated', repositionQuotePricing);
document.addEventListener('DOMContentLoaded', updateRentalCartPricing);
document.addEventListener('DOMContentLoaded', updateQuotePagePricing);
document.addEventListener('DOMContentLoaded', repositionQuotePricing);

// ── SKU wiring — passes Shopify SKU (= RMS product ID) through the cart ──
// sku-in-cart
(function() {
  // 1. When the page has an Add to Rental Cart button, capture the SKU
  //    Store it in a map keyed by product handle so we can attach it to cart items
  var skuMap = {};

  document.addEventListener('DOMContentLoaded', function() {
    var btn = document.querySelector('.rental-cart-add-btn');
    if (!btn) return;
    var handle = btn.getAttribute('data-product-handle');
    var sku    = btn.getAttribute('data-product-sku');
    if (handle && sku) skuMap[handle] = sku;
  });

  // 2. Patch the gear list builder used by the klaviyo-rental-quote block
  //    so that each line gets #SKU appended where available
  var _origGetCart = null;
  var _patchApplied = false;

  function applyGearListSkuPatch() {
    if (_patchApplied || typeof RentalCart === 'undefined') return;
    _patchApplied = true;

    var originalGetCart = RentalCart.getCart;
    if (!originalGetCart) return;

    // Build a handle→sku map from all buttons on the page
    document.querySelectorAll('.rental-cart-add-btn').forEach(function(b) {
      var h = b.getAttribute('data-product-handle');
      var s = b.getAttribute('data-product-sku');
      if (h && s) skuMap[h] = s;
    });

    // Store SKU on cart items — patch RentalCart.addItem to capture sku
    var _origAddItem = RentalCart.addItem;
    RentalCart.addItem = function(item) {
      // item.id on real product page = handle or variant id
      // Try to find the button on the page to get the sku
      var btn = document.querySelector('.rental-cart-add-btn');
      if (btn) {
        var sku = btn.getAttribute('data-product-sku');
        var handle = btn.getAttribute('data-product-handle');
        if (sku) { item.sku = sku; skuMap[item.id] = sku; }
        if (handle) skuMap[handle] = sku;
      }
      return _origAddItem.call(this, item);
    };
  }

  document.addEventListener('DOMContentLoaded', applyGearListSkuPatch);
  document.addEventListener('rental-cart:updated', applyGearListSkuPatch);

  // 3. Patch the gear list string to append #SKU to each line
  //    The gear list is built in the klaviyo-rental-quote DOMContentLoaded block
  //    We intercept it by overriding how cart items are serialised
  var _origGetCartFn = null;
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof RentalCart === 'undefined' || !RentalCart.getCart) return;

    // Patch getCart to attach SKU to each item from our skuMap
    var _orig = RentalCart.getCart;
    RentalCart.getCart = function() {
      var cart = _orig.call(this);
      if (cart && cart.items) {
        cart.items = cart.items.map(function(item) {
          var sku = item.sku || skuMap[item.id] || skuMap[item.handle] || null;
          if (sku) item.sku = sku;
          return item;
        });
      }
      return cart;
    };
  });
})();

// Override gear list builder to include SKU
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('rental-quote-form');
    if (!form) return;

    // Patch the submit listener — wrap existing to enrich gear list with SKUs
    form.addEventListener('submit', function() {
      // Re-build the gear list with SKU appended as #ID
      try {
        var cart = RentalCart.getCart ? RentalCart.getCart() : null;
        if (!cart || !cart.items || !cart.items.length) return;

        var enrichedLines = cart.items.map(function(item) {
          var rate      = Math.round((item.price || 0) / 100);
          var dur       = item.duration || 1;
          var qty       = item.qty || 1;
          var lineTotal = rate * dur * qty;
          var skuTag    = item.sku ? ' #' + item.sku : '';
          return item.title
            + ' (' + dur + 'd'
            + ' x' + qty
            + ' @$' + rate + '/d)'
            + ' $' + lineTotal
            + skuTag;
        }).join('\n');

        var field = document.getElementById('rq-items-field');
        if (field && enrichedLines) field.value = enrichedLines;
      } catch(e) {}
    }, true); // capture phase — runs before the existing submit listeners
  });
})();

// ── Rental Form v2 — delivery options + flatpickr dates ──────────────────
// rental-form-v2
(function() {

  // Wait for flatpickr to load (added via CDN in theme.liquid)
  function whenFlatpickrReady(cb) {
    if (typeof flatpickr !== 'undefined') { cb(); return; }
    var attempts = 0;
    var t = setInterval(function() {
      attempts++;
      if (typeof flatpickr !== 'undefined') { clearInterval(t); cb(); }
      else if (attempts > 50) { clearInterval(t); console.warn('flatpickr did not load'); }
    }, 100);
  }

  // Build 30-minute time slots from 7:00 AM to 7:30 PM
  function buildTimeSlots() {
    var slots = [];
    for (var h = 7; h <= 19; h++) {
      for (var m = 0; m < 60; m += 30) {
        if (h === 19 && m > 30) continue;
        var hr12 = h > 12 ? h - 12 : (h === 0 ? 12 : h);
        var ampm = h >= 12 ? 'PM' : 'AM';
        var min  = m === 0 ? '00' : '30';
        slots.push(hr12 + ':' + min + ' ' + ampm);
      }
    }
    return slots;
  }

  // Format Date as DD-MMM-YYYY (e.g. 25-Jun-2026)
  function formatDate(d) {
    if (!d) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = months[d.getMonth()];
    var yy = d.getFullYear();
    return dd + '-' + mm + '-' + yy;
  }

  // Parse DD-MMM-YYYY back to Date
  function parseDate(str) {
    if (!str) return null;
    var m = str.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/);
    if (!m) return null;
    var months = {Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};
    return new Date(parseInt(m[3]), months[m[2]], parseInt(m[1]));
  }

  // Shared state keys in localStorage so dates sync across cart drawer + quote page
  var DATE_KEY = 'rentalShootDates';
  function loadDates() {
    try { return JSON.parse(localStorage.getItem(DATE_KEY) || 'null'); } catch(e) { return null; }
  }
  function saveDates(start, end) {
    try { localStorage.setItem(DATE_KEY, JSON.stringify({ start: start ? start.toISOString() : null, end: end ? end.toISOString() : null })); } catch(e) {}
    document.dispatchEvent(new CustomEvent('rental-dates:updated'));
  }

  function init() {
    var pageDatesInput = document.getElementById('rq-page-dates');
    var deliverySelect = document.getElementById('rq-delivery');
    var deliveryExtra  = document.getElementById('rq-delivery-extra');
    var deliveryTime   = document.getElementById('rq-delivery-time');
    var datesField     = document.getElementById('rq-dates-field');
    var drawerStart    = document.getElementById('rental-start-date');
    var drawerEnd      = document.getElementById('rental-end-date');

    // ── 1. Populate delivery time slots ────────────────────────────────────
    if (deliveryTime && deliveryTime.options.length <= 1) {
      // Clear and add a placeholder option first
      deliveryTime.innerHTML = '';
      var phOpt = document.createElement('option');
      phOpt.value = ''; phOpt.text = '— Select time —';
      phOpt.disabled = true; phOpt.selected = true;
      deliveryTime.appendChild(phOpt);
      // Then the actual time slots
      var slots = buildTimeSlots();
      slots.forEach(function(s) {
        var opt = document.createElement('option');
        opt.value = s; opt.text = s;
        deliveryTime.appendChild(opt);
      });
    }

    // ── 2. Conditional show/hide delivery details ──────────────────────────
    function toggleDeliveryExtra() {
      if (!deliverySelect || !deliveryExtra) return;
      var v = deliverySelect.value || '';
      var show = v === 'Delivery' || v === 'Delivery & Collection';
      deliveryExtra.style.display = show ? 'block' : 'none';
      // Toggle required attribute on conditional fields
      ['rq-delivery-postcode', 'rq-delivery-suburb', 'rq-delivery-time'].forEach(function(id) {
        var f = document.getElementById(id);
        if (f) { if (show) f.setAttribute('required','required'); else f.removeAttribute('required'); }
      });
    }
    if (deliverySelect) {
      deliverySelect.addEventListener('change', toggleDeliveryExtra);
      toggleDeliveryExtra();
    }

    // ── 3. flatpickr range picker on the quote page ────────────────────────
    var pageFp = null;
    if (pageDatesInput) {
      var stored = loadDates();
      var defaults = stored && stored.start && stored.end ? [new Date(stored.start), new Date(stored.end)] : [];
      pageFp = flatpickr(pageDatesInput, {
        mode: 'range',
        dateFormat: 'd-M-Y',
        minDate: 'today',
        defaultDate: defaults,
        onChange: function(selectedDates) {
          if (selectedDates.length === 2) {
            saveDates(selectedDates[0], selectedDates[1]);
            // Update hidden field for form submission
            if (datesField) datesField.value = formatDate(selectedDates[0]) + ' to ' + formatDate(selectedDates[1]);
            // Sync to drawer native date inputs (ISO format)
            if (drawerStart) drawerStart.value = selectedDates[0].toISOString().slice(0,10);
            if (drawerEnd)   drawerEnd.value   = selectedDates[1].toISOString().slice(0,10);
          }
        }
      });
    }

    // ── 4. Convert drawer date inputs to flatpickr with the same format ────
    if (drawerStart && drawerEnd) {
      // Replace native date pickers with flatpickr DD-MMM-YYYY
      var startFp = flatpickr(drawerStart, {
        dateFormat: 'd-M-Y',
        minDate: 'today',
        altInput: true,
        altFormat: 'd-M-Y',
        onChange: function(selectedDates) {
          if (selectedDates[0]) {
            var endStored = loadDates();
            var endDate = endStored && endStored.end ? new Date(endStored.end) : selectedDates[0];
            saveDates(selectedDates[0], endDate);
            if (pageFp) pageFp.setDate([selectedDates[0], endDate], false);
            if (datesField) datesField.value = formatDate(selectedDates[0]) + ' to ' + formatDate(endDate);
          }
        }
      });
      var endFp = flatpickr(drawerEnd, {
        dateFormat: 'd-M-Y',
        minDate: 'today',
        altInput: true,
        altFormat: 'd-M-Y',
        onChange: function(selectedDates) {
          if (selectedDates[0]) {
            var startStored = loadDates();
            var startDate = startStored && startStored.start ? new Date(startStored.start) : selectedDates[0];
            saveDates(startDate, selectedDates[0]);
            if (pageFp) pageFp.setDate([startDate, selectedDates[0]], false);
            if (datesField) datesField.value = formatDate(startDate) + ' to ' + formatDate(selectedDates[0]);
          }
        }
      });
    }

    // ── 5. On submit, include the delivery fields in the form payload ──────
    var form = document.getElementById('rental-quote-form');
    if (form) {
      form.addEventListener('submit', function() {
        // Leave the delivery dropdown alone — it submits its own value as contact[Delivery Method]
        // Postcode, Suburb, and Time are also submitted as separate contact[] fields automatically.
        // The Railway endpoint reads them individually.
      }, true); // capture phase — runs before other submit handlers
    }
  }

  whenFlatpickrReady(function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });
})();

// ============================================================
// Draft Order — POST to lunar-website-proxy BEFORE cart is cleared
// Capture-phase handler so it runs before the cart-clearing handler.
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('rental-quote-form');
  if (!form) return;

  form.addEventListener('submit', function() {
    try {
      var fn = (document.getElementById('rq-first-name')  || {}).value || '';
      var ln = (document.getElementById('rq-last-name')   || {}).value || '';
      var em = (document.getElementById('rq-email')       || {}).value || '';
      var ph = (document.getElementById('rq-phone')       || {}).value || '';
      var co = (document.getElementById('rq-company')     || {}).value || '';
      var st = (document.getElementById('rq-shoot-type')  || {}).value || '';
      var dl = (document.getElementById('rq-delivery')    || {}).value || '';
      var dlPostcode = (document.getElementById('rq-delivery-postcode') || {}).value || '';
      var dlSuburb   = (document.getElementById('rq-delivery-suburb')   || {}).value || '';
      var dlTime     = (document.getElementById('rq-delivery-time')     || {}).value || '';
      var nt = (document.getElementById('rq-notes')       || {}).value || '';
      var sd = (document.getElementById('rq-dates-field') || {}).value || '';
      var qr = (document.getElementById('rq-ref-field')   || {}).value || '';
      if (!em) return;

      var _cart = (typeof RentalCart !== 'undefined' && RentalCart.getCart) ? RentalCart.getCart() : null;
      var _items = (_cart && _cart.items) ? _cart.items : [];
      var _payloadItems = _items
        .filter(function(it) { return it.variantId; })
        .map(function(it) {
          return {
            variant_id: it.variantId,
            title: it.title,
            duration: it.duration || 1,
            qty: it.qty || 1,
            price_cents: it.price || 0
          };
        });

      if (_payloadItems.length > 0) {
        fetch('https://lunar-website-proxy-production.up.railway.app/create-draft-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            first_name: fn, last_name: ln, email: em, phone: ph,
            company: co, shoot_type: st, delivery: dl,
            delivery_postcode: dlPostcode, delivery_suburb: dlSuburb, delivery_time: dlTime,
            notes: nt, shoot_dates: sd, quote_ref: qr,
            cart_items: _payloadItems
          })
        }).catch(function() {});
      }
    } catch (e) {}
  }, true); // <-- capture phase: runs BEFORE any other submit handler
});
// ============================================================
// Collection cards — "Add to Rental Quote"
// Adds a gear-hire product to the rental cart straight from the grid.
// Delegated so it also works for cards loaded via infinite scroll.
// ============================================================
(function () {
  function markAdded(btn) {
    btn.classList.add('added');
    btn.textContent = '\u2713 Added';
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof RentalCart === 'undefined') return;
    document.querySelectorAll('.rental-quote-card-btn').forEach(function (btn) {
      if (RentalCart.isInCart(btn.dataset.productId)) markAdded(btn);
    });
  });

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('.rental-quote-card-btn');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();            // don't trigger the card's product link
    if (btn.classList.contains('added')) return;

    RentalCart.addItem({
      id:        btn.dataset.productId,
      handle:    btn.dataset.productHandle,
      title:     btn.dataset.productTitle,
      brand:     btn.dataset.productVendor,
      image:     btn.dataset.productImage,
      price:     parseInt(btn.dataset.productPrice, 10),
      variantId: btn.dataset.productVariantId,
      sku:       btn.dataset.productSku,
      duration:  1,
      qty:       1
    });

    markAdded(btn);
  });
})();
// ============================================================
// Quote page — editable day/qty steppers
// ============================================================

// Duration updater (qty already exists as RentalCart.updateQty)
RentalCart.updateDuration = function (id, oldDuration, newDuration) {
  var cart = RentalCart.getCart();
  newDuration = Math.max(1, parseInt(newDuration, 10) || 1);
  var items = cart.items || [];
  var item = items.find(function (i) { return i.id == id && i.duration == oldDuration; });
  if (!item) return;
  var twin = items.find(function (i) { return i.id == id && i.duration == newDuration && i !== item; });
  if (twin) {                                   // merge if a line at the new duration already exists
    twin.qty += item.qty;
    cart.items = items.filter(function (i) { return i !== item; });
  } else {
    item.duration = newDuration;
  }
  RentalCart.saveCart(cart);
};

document.addEventListener('click', function (ev) {
  var btn = ev.target.closest('.rq-stepper__btn');
  if (!btn || !btn.closest('#rental-quote-pricing-rows')) return;  // quote-page table only
  ev.preventDefault();

  var stepper = btn.closest('.rq-stepper');
  var id    = stepper.dataset.id;
  var dur   = parseInt(stepper.dataset.duration, 10);
  var field = stepper.dataset.field;
  var step  = parseInt(btn.dataset.step, 10);

  var cart = RentalCart.getCart();
  var item = (cart.items || []).find(function (i) { return i.id == id && i.duration == dur; });
  if (!item) return;

  if (field === 'qty') {
    RentalCart.updateQty(id, dur, Math.max(1, (item.qty || 1) + step));
  } else if (field === 'duration') {
    RentalCart.updateDuration(id, dur, Math.max(1, (item.duration || 1) + step));
  }
  // saveCart fires 'rental-cart:updated' → the table re-renders automatically
});